import { LANE_DISPLAY_LABEL, LANE_FILTER_DB_ORDER } from './laneDisplay';

interface DataSelectorLaneFilterProps {
  selectedLane: string;
  onLaneChange: (lane: string) => void;
}

/** ランク帯と並べる用。注意書きは親の `data-selector__lane-note` に置く */
export function DataSelectorLaneFilter({
  selectedLane,
  onLaneChange,
}: DataSelectorLaneFilterProps) {
  return (
    <div className="selector-group lane-filter-group">
      <label htmlFor="tier-lane-filter">レーン</label>
      <select
        id="tier-lane-filter"
        value={selectedLane}
        onChange={(e) => onLaneChange(e.target.value)}
        className="selector-dropdown"
      >
        <option value="all">すべて</option>
        {LANE_FILTER_DB_ORDER.map((db) => (
          <option key={db} value={db}>
            {LANE_DISPLAY_LABEL[db] ?? db}
          </option>
        ))}
      </select>
    </div>
  );
}
